<template>
    <v-btn color="primary"
           class="mr-1"
           to="/stock/stocktakesheet"
           prepend-icon="mdi-counter">
        STOCKTAKE
    </v-btn>
</template>
<style scoped>

</style>
<script>
    import { mapActions, mapState } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
        };
    }
    export default {
        name: "StocktakeLoader",
        data: function () {
            return initialState();
        },
        mounted: function () {
            const today = this.$dayjs();
            this.date = today.format('YYYY-MM-DD');
        },
        props: {
        },
        methods: {
            ...mapActions([
                "showSuccessSnack",
                "showErrorSnack",
            ]),
        },
        computed: {
        }
    };
</script>